import { Record } from 'immutable';
const defaults = {
  paymentStatus: 'UNINITIALIZED',
  paymentSessionId: null,
  finalPrice: null
};
export default class PaidMeetingLifecycle extends Record(defaults) {}